import { Checkbox } from "../../Checkbox"
import { IResponsiveColumnSize } from "../../../../../base/styles"
import { SelectColumnSize } from "./SelectColumnSize"
import clsx from "clsx"
import { useState } from "react"

export const EditColumnSize = ({ title, value, className, onChange }: {
    title: string,
    value: IResponsiveColumnSize,
    className?: string,
    onChange: (value?: IResponsiveColumnSize) => void
}) => {
    const [responsive, setResponsive] = useState<boolean>();

    return (
        <div className={clsx(className)}>
            <div className="d-flex align-items-end">
                <SelectColumnSize
                    title={title}
                    className="flex-grow-1 pe-2"
                    onChange={(newValue) => { onChange({ ...value, allSizes: newValue }) }}
                    value={value?.allSizes} />
                <Checkbox
                    title="Responsive"
                    className="fs-8 fw-semibold"
                    value={responsive === true}
                    onChange={setResponsive} />
            </div>

            {responsive &&
                <div className="d-flex flex-row flex-wrap mx-5 my-3">
                    <SelectColumnSize
                        title="Small"
                        className="w-50 pe2"
                        onChange={(newValue) => { onChange({ ...value, small: newValue }) }}
                        value={value?.small} />
                    <SelectColumnSize
                        title="Medium"
                        className="w-50 pe2"
                        onChange={(newValue) => { onChange({ ...value, medium: newValue }) }}
                        value={value?.medium} />
                    <SelectColumnSize
                        title="Large"
                        className="w-50 pe2"
                        onChange={(newValue) => { onChange({ ...value, large: newValue }) }}
                        value={value?.large} />
                    <SelectColumnSize
                        title="Ex. Large"
                        className="w-50 pe2"
                        onChange={(newValue) => { onChange({ ...value, xLarge: newValue }) }}
                        value={value?.xLarge} />
                    <SelectColumnSize
                        title="Ex. Large +"
                        className="w-50 pe2"
                        onChange={(newValue) => { onChange({ ...value, xxLarge: newValue }) }}
                        value={value?.xxLarge} />
                </div>}
        </div>
    )
}